import { useEffect } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import {
    OrangeModal,
    PurpleModal,
    GreenModal,
    BlueModal,
    BlackModal
} from "./components/assets";
import {
    iconCollectionSoftwareDev,
    iconCollectionMarketing,
    iconCollectionIt,
    iconCollectionDesign,
    iconCollectionOperations
} from "./constants/constants";
import { TemplateKey } from "./constants/constants";
import { useHeroState } from "./util/hero-context";

import {
    ProductModalCard,
    ProductModalCarousel,
    ProductModalCardType
} from ".";

const modalBackgroundStyles = css({
    position: "fixed",
    insetInlineStart: "0",
    insetBlockStart: "0",
    insetInlineEnd: "0",
    insetBlockEnd: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
        "var(--DarkNeutral-Opaque-DarkNeutral-100, rgba(16, 18, 20, 0.85))",
    zIndex: "10",
    [media.above.lg]: {
        display: "none"
    }
});

export const JswProductModalCarousel = () => {
    const { modalIndex } = useHeroState();

    // Disable scroll if modal is open
    useEffect(() => {
        if (modalIndex !== -1) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [modalIndex]);

    const JswProductTourModalCards: Array<ProductModalCardType> = [
        {
            eyebrow: "product and issue tracking",
            title: "Software Development",
            description:
                "Plan, track, release and support world-class software. Jira is the single source of truth for your entire development lifecycle.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardSoftwareDev.webp",
            iconCollection: iconCollectionSoftwareDev,
            BackgroundImage: OrangeModal,
            ctaLink: `/software/jira/free?jiraProductTourSignupType=software-development`,
            label: "software-development"
        },
        {
            eyebrow: "build creative workflows",
            title: "Marketing",
            description:
                "Make launching viral marketing campaigns a breeze. Break down complex campaigns into actionable steps, easily collect requests, and stay aligned with cross-functional teams.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardMarketing.webp",
            iconCollection: iconCollectionMarketing,
            BackgroundImage: PurpleModal,
            ctaLink: `/software/jira/free?templateId=${TemplateKey.GoToMarket}`,
            label: "marketing"
        },
        {
            eyebrow: "manage and track requests",
            title: "IT support services",
            description:
                "Easily build custom forms, track requests, and fully automate your intake process. Communicate progress and collaborate directly on requests with internal stakeholders in one place.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardIt.webp",
            iconCollection: iconCollectionIt,
            BackgroundImage: GreenModal,
            ctaLink: `/software/jira/free?jiraProductTourSignupType=it`,
            label: "it"
        },
        {
            eyebrow: "build creative workflows",
            title: "Design",
            description:
                "Collaborate on, organize, and deliver creative requests with ease. Give real-time visibility into designs with Jira’s Figma integration and accelerate approvals.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardDesign.webp",
            iconCollection: iconCollectionDesign,
            BackgroundImage: BlueModal,
            ctaLink: `/software/jira/free?templateId=${TemplateKey.WebDesignProcess}`,
            label: "design"
        },
        {
            eyebrow: "create intake processes",
            title: "Operations",
            description:
                "Manage procurement, office, and new vendor requests, craft new operational processes, monitor operational risks and more. Keep your company running at maximum efficiency with Jira.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardOps.webp",
            iconCollection: iconCollectionOperations,
            BackgroundImage: BlackModal,
            ctaLink: `/software/jira/free?templateId=${TemplateKey.SimplifiedProcessControl}`,
            label: "operations"
        }
    ];

    return (
        <div>
            {modalIndex !== -1 && (
                <>
                    {/* desktop */}
                    <ProductModalCarousel>
                        {JswProductTourModalCards.map((props, idx) => {
                            return <ProductModalCard key={idx} {...props} />;
                        })}
                    </ProductModalCarousel>
                    {/* Tablet / Mobile */}
                    <div css={modalBackgroundStyles}>
                        <ProductModalCard
                            {...(JswProductTourModalCards[
                                modalIndex
                            ] as ProductModalCardType)}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
